import { DsShadow, IconButton, Icons } from '@cast/design-system';

export const ScrollToBottom = ({
  onClick,
}: {
  onClick: (behavior?: ScrollBehavior) => void;
}) => {
  return (
    <IconButton
      sx={(theme) => ({
        position: 'absolute',
        top: -70,
        right: 15,
        transform: 'translateX(-50%)',
        borderRadius: '100%',
        width: '40px',
        height: '40px',
        transition: 'background-color 0.2s ease-in-out',
        boxShadow: theme.shadows[DsShadow.HOVER],
      })}
      variant="secondary"
      type="button"
      onClick={() => onClick()}
    >
      <Icons.ArrowDown size={20} />
    </IconButton>
  );
};
